import {
  CUSTOM_FIELD_FILTER_KEY,
  FILTER_KEYS,
  OPERATOR_KEYS,
} from "../../../constants/conversationFilter";
import { FilterActionTypes } from "./actionTypes";

export const CUSTOM_FIELD_PREFIX = "custom_field_";
export const OPERATOR_SUFFIX = "_op";

export const TAGS_OPERATOR_KEY = `${FILTER_KEYS.TAGS_FILTER}${OPERATOR_SUFFIX}`;
export const WIHTOUT_TAGS_OPERATOR_KEY = `${FILTER_KEYS.WITHOUT_TAGS_FILTER}${OPERATOR_SUFFIX}`;

export const filterReducerInititalState = {
  activeFilter: "",
  [TAGS_OPERATOR_KEY]: OPERATOR_KEYS.ANY,
  [WIHTOUT_TAGS_OPERATOR_KEY]: OPERATOR_KEYS.ANY,
};

export const filterReducer = (state, action) => {
  switch (action.type) {
    case FilterActionTypes.SET_FILTER: {
      const { name, op, values, custom_field_id } = action.payload;

      const filterkey =
        name === CUSTOM_FIELD_FILTER_KEY
          ? `${CUSTOM_FIELD_PREFIX}${custom_field_id}`
          : name;

      return {
        ...state,
        [filterkey]: {
          op,
          values,
          ...(name === CUSTOM_FIELD_FILTER_KEY ? { custom_field_id } : {}),
        },
      };
    }

    case FilterActionTypes.SET_ACTIVE_FILTER: {
      const { name } = action.payload;
      return {
        ...state,
        activeFilter: name,
      };
    }

    case FilterActionTypes.SET_TAGS_OPERATOR: {
      const { operator } = action.payload;
      return {
        ...state,
        [TAGS_OPERATOR_KEY]: operator,
      };
    }

    case FilterActionTypes.SET_WITHOUT_TAGS_OPERATOR: {
      const { operator } = action.payload;
      return {
        ...state,
        [WIHTOUT_TAGS_OPERATOR_KEY]: operator,
      };
    }

    case FilterActionTypes.RESET:
      return filterReducerInititalState;

    default:
      return state;
  }
};
